import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { map } from 'rxjs/operators';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { whiteSpace } from 'src/assets/white-space';

@Component({
  selector: 'lifedi-standard-informant',
  templateUrl: './standard-informant.component.html',
  styleUrls: ['./standard-informant.component.scss']
})
export class StandardInformantComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  @ViewChildren('allcanvas') myCharts: any;

  isLoading: boolean = false;
  data_report;

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    this.isLoading = true;
    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    this.getReport(body);
  }

  getReport(body) {
    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          this.data_report = res.result;

          setTimeout(() => {
            let zscore = ['', '-2', '-1', '0', '1', '2', ''];
            let pandtscore = ['', '0', '25', '50', '75', '100', ''];
            let curve_data = [0.01, 0.2, 1.35, 4, 1.35, 0.2, 0.01];

            for (let i = 0; i < this.data_report.data.length; i++) {
              // console.log(this.data_report);
              let data = {
                labels:
                  this.data_report.data[i].type_output === 'zscore'
                    ? zscore
                    : pandtscore,
                datasets: [
                  {
                    data: curve_data,
                    fill: true,
                    pointRadius: 0,
                    backgroundColor: 'rgba(195, 195, 195, 0.5)',
                    borderColor: 'rgba(0, 0, 0, 0.25)',
                    borderWidth: 1,
                  },
                ],
              };

              let dataInf = {
                labels:
                  this.data_report.data2[i].type_output === 'zscore'
                    ? zscore
                    : pandtscore,
                datasets: [
                  {
                    data: curve_data,
                    fill: true,
                    pointRadius: 0,
                    backgroundColor: 'rgba(195, 195, 195, 0.5)',
                    borderColor: 'rgba(0, 0, 0, 0.25)',
                    borderWidth: 1,
                  },
                ],
              };

              let elements = {
                line: {
                  tension: 0.5,
                },
              },

                scales = {
                  y: {
                    beginAtZero: true,
                    max: 4.5,
                    ticks: {
                      display: false,
                    },
                  },
                };

              let myChart1 = new Chart('StandardChart' + i, {
                type: 'line',
                data: data,
                options: {
                  elements: elements,
                  scales: scales,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report.data[i].value_chart,
                          xMax: +this.data_report.data[i].value_chart,
                          borderColor: this.data_report.data[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report.data[i].value).toFixed(2),
                            backgroundColor: this.data_report.data[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });

              var myChart2 = new Chart('StandardChartpdf' + i, {
                type: 'line',
                data: data,
                options: {
                  elements: elements,
                  scales: scales,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report.data[i].value_chart,
                          xMax: +this.data_report.data[i].value_chart,
                          borderColor: this.data_report.data[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report.data[i].value).toFixed(2),
                            backgroundColor: this.data_report.data[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });

              let myChart3 = new Chart('StandardChartInformant' + i, {
                type: 'line',
                data: dataInf,
                options: {
                  elements: elements,
                  scales: scales,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report.data2[i].value_chart,
                          xMax: +this.data_report.data2[i].value_chart,
                          borderColor: this.data_report.data2[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report.data2[i].value).toFixed(2),
                            backgroundColor: this.data_report.data2[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });

              var myChart4 = new Chart('StandardChartpdfInformant' + i, {
                type: 'line',
                data: dataInf,
                options: {
                  elements: elements,
                  scales: scales,
                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: [
                        {
                          type: 'line',
                          xMin: +this.data_report.data2[i].value_chart,
                          xMax: +this.data_report.data2[i].value_chart,
                          borderColor: this.data_report.data2[i].color,
                          borderWidth: 2,
                          label: {
                            enabled: true,
                            color: 'white',
                            content: parseFloat(this.data_report.data2[i].value).toFixed(2),
                            backgroundColor: this.data_report.data2[i].color,
                          },
                        },
                      ],
                    },
                  },
                },
              });
            }
          }, 100);
          setTimeout(() => {
            this.filepdf('email');
            this.isLoading = true;
          }, 1000);
        })
      )
      .subscribe();
  }

  filepdf(transfer) {
    let formattedDate = new DateTimePipe().transform(
      this.data_report.done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report.user_id;
    let alldata = this.data_report;
    let standardPdf = [];
    let standardPdfInformant = [];
    for (let i = 0; i < alldata.data.length; i++) {
      let a = document.getElementById('StandardChartpdf' + i);
      standardPdf.push(a);
    }

    for (let i = 0; i < alldata.data.length; i++) {
      let a = document.getElementById('StandardChartpdfInformant' + i);
      standardPdfInformant.push(a);
    }

    Promise.all([...standardPdf, ...standardPdfInformant].map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        // console.log(dataArray);
        let halfIndex = Math.ceil(dataArray.length / 2);
        let std = dataArray.slice(0, halfIndex);
        let stdInf = dataArray.slice(halfIndex);

        // console.log(std, stdInf);
        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: userid + ' | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report.reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report.report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              table: {
                headerRows: 1,
                widths: [100],
                heights: [-4],
                body: [
                  [
                    {
                      text: 'ผู้ทำแบบทดสอบ',
                      fontSize: 13,
                      bold: true,
                      aligment: 'center',
                      fillColor: '#060e9f',
                      border: [true, true, true, true],
                      color: '#ffffff',
                      alignment: 'center',
                      margin: [0, 0],
                      borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                    }
                  ]
                ]
              }
            },
            {
              image: std[0],
              width: 300,
              alignment: 'center',
              margin: [0, 40],
              pageBreak: '',
            },
            {
              text: this.data_report.data[0].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report.data[0].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report.data[0].min +
                ' คะแนนสูงสุด : ' +
                this.data_report.data[0].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report.data[0].value).toFixed(2) +
                ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report.data[0].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < alldata.data.length; i++) {
          allPage.content.push(
            {
              image: std[i],
              width: 300,
              alignment: 'center',
              margin: [0, 20],
              pageBreak: 'before',
            },
            {
              text: this.data_report.data[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report.data[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report.data[i].min +
                ' คะแนนสูงสุด : ' +
                this.data_report.data[i].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report.data[i].value).toFixed(2) +
                ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report.data[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            }
          );
        }

        let parances = [];
        this.data_report.parances.forEach(e => {
          parances.push(`${e.EMAIL} (${e.TAG})`)
        });
        let parancesStr = (parances.join()).replace(/,/g, ', ')

        allPage.content.push(
          {
            image: whiteSpace, // ใส่กรณีที่ text ใส่ pageBreak ไม่ได้
            width: 300,
            alignment: 'center',
            margin: [0, 0],
            pageBreak: 'before',
          },
          {
            text: '',
            width: '*',
            fontSize: 14,
            margin: [0, 0, 0, 5],
          },
          {
            table: {
              headerRows: 1,
              widths: [120],
              heights: [-5],
              body: [
                [
                  {
                    text: 'ผู้มีส่วนร่วมในแบบทดสอบนี้',
                    fontSize: 15,
                    bold: true,
                    aligment: 'center',
                    fillColor: '#060e9f',
                    border: [true, true, true, true],
                    color: '#ffffff',
                    alignment: 'center',
                    margin: [0, 0],
                    borderColor: ['#060e9f', '#060e9f', '#060e9f', '#060e9f'],
                  }
                ]
              ]
            }
          },
          {
            text: 'รายงานผลของผู้มีส่วนร่วมนี้เป็นของ',
            alignment: 'left',
            fontSize: 16,
            color: '#000',
            margin: [0, 10, 0, 8],
            bold: true,
          },
          {
            text: parancesStr,
            width: '*',
            fontSize: 15,
            margin: [0, 0, 0, 25],
          },
        )

        for (let i = 0; i < alldata.data2.length; i++) {
          allPage.content.push(
            {
              image: stdInf[i],
              width: 300,
              alignment: 'center',
              margin: [0, 20],
              pageBreak: i === 0 ? '' : 'before',
            },
            {
              text: this.data_report.data2[i].psy_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report.data2[i].psy_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report.data2[i].min +
                ' คะแนนสูงสุด : ' +
                this.data_report.data2[i].max,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report.data2[i].value).toFixed(2) +
                ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report.data2[i].range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            }
          );
        }

        if (transfer === 'email') {
          let pdfDocGenerator = pdfMake.createPdf(allPage);
          pdfDocGenerator.getBase64((base64str) => {
            // console.log(base64str);
            let data = {
              MEASURE_ID: this.measureid,
              TYPE: this.type,
              base64str: base64str,
              view: this.view_status,
            };
            this.measureService.SaveReportMeasureId(data).subscribe((res) => {
              // console.log(res);
            });
          });
        } else if (transfer === 'download') {
          pdfMake.createPdf(allPage).open();
        }
      }
    );
  }

}
